<template>
  <div class="PurchaseOrderList">
    <Card dis-hover :bordered="false">
      <page-form ref="formDataName" :formData="formData" @onSubmit="reSearch" :needValidation="true" :loading="loading"></page-form>

      <Tabs v-model="currentPanel" @on-click="tabsClick" :animated="false">
        <TabPane :label="$t('purchaseOrderSearch.orderDeail')" name="info1">
          <table style="margin-bottom: 10px">
            <tr>
              <td>
                <Button type="primary" @click="exportOrderDetailAsyncExcel" :loading="exportLoading" :disabled="resultSource.list<=0">{{$t('common.export')}}</Button>
                <set-table class="ml10" :columns="orderDeail_columns" uniqueKey="detail" @setTableUpdate="setDetailTableUpdate"></set-table>
            </td>
            </tr>
          </table>

          <EditTable ref="detailTable"
                     :columns="orderDeail_columns"
                     v-model="resultSource.list"
                     :editingAll="editing"
                     size="small"
                     :height="400"
                     :loading="loading"
                     needScrollBar
                     needSticky
                     @on-selection-change="handleSelectionChange"
          >
          </EditTable>
          <pagination :currentPage="page" :total="resultSource.total" size="small" style="padding-top:15px" :pageSize="pageSize" show-elevator
                      show-sizer @on-current-page-change="pageChage" @on-page-size-change="pageSizeChange" :transfer="true" placement="top"></pagination>
        </TabPane>
        <TabPane :label="$t('purchaseOrderSearch.orderCount')" name="info2">
          <table style="margin-bottom: 10px">
            <tr>
              <td>
                <Button type="primary" :loading="exportLoading" :disabled="resultSourceCount.list<=0" @click="exportOrderCountAsyncExcel">{{$t('common.export')}}</Button>
                <set-table class="ml10" :columns="orderCount_columns" uniqueKey="sum" @setTableUpdate="setSumTableUpdate"></set-table>
              </td>
            </tr>
          </table>
          <Table border ref="tableId" :columns="orderCount_columns" :data="resultSourceCount.list" size="small" :loading="loading" :height="400"></Table>
          <pagination :currentPage="pageCount" :total="resultSourceCount.total" size="small" style="padding-top:15px" :pageSize="pageSizeCount"
                      show-elevator
                      show-sizer @on-current-page-change="pageChageCount" @on-page-size-change="pageSizeChangeCount" :transfer="true" placement="top"></pagination>
        </TabPane>
      </Tabs>
    </Card>
  </div>
</template>
<style scoped lang='less'>
  .layout {
    margin: 10px;
    height: 100%;
    background-color: #fff;

  .title {
    margin-bottom: 30px;
  }

  .btnLst {

  button {
    width: 100px;
  }

  }
  }
</style>
<style lang="less">
  #formMain .m-form-item .m-form-item, #queryMain .m-form-item .m-form-item{
    margin-bottom: 0;
  }
</style>
<script>
  import moment from 'moment';
  import EditTable from '@/components/awesome/page/edit-table';
  import pageForm from '@/components/awesome/page/query/index';
  import pagination from '@/components/awesome/page/pagination/index';
  import axios from 'axios';
  export default {
    name: 'PurchaseOrderList',
    components: {
      pageForm,
      EditTable,
      pagination
    },
    data() {
      return {
        INT_BONDED_TYPE: [],
        currLang: this.$i18n.locale,
        vendorUser: {},
        orgList: [],
        exportLoading: false,
        saveFistSearchDateUrl: '/gscapp/plannedOrder/purchaseOrder/saveFistSearchDate',
        selection: [],
        supplierId: '',
        supplierCode: '',
        mdmCode: '', // IERP的供应商编码
        vendorId: '',
        gysCode: '',
        editing: false,
        currentPanel: 'info1',
        page: 1,
        pageSize: 100,
        pageCount: 1,
        pageSizeCount: 10,
        loading: false,
        exporting: false,
        queryParam: [],
        orderCount_columns: [ // 订单汇总
          {
            title: this.$t('purchaseOrderSearch.xqrq'), // 需求日期
            key: 'demandDate',
            align: 'center',
            render: (h, params) => {
              return h('span', {}, moment(params.row.demandDate).format('YYYY-MM-DD'));
            },
            width: 120
          },
          {
            title: this.$t('purchaseOrderSearch.wlbm'), // 物料编码
            key: 'itemCode',
            align: 'center',
            minWidth: 160
          },
          {
            title: this.$t('purchaseOrderSearch.wlms'), // 物料描述
            key: 'itemDescription',
            align: 'center',
            minWidth: 300,
            render: (h, params) => {
              return h('Tooltip', {
                props: {
                  content: params.row.itemDescription,
                  placement: 'top'
                },
                class: 'm-tooltip-overflow'
              }, params.row.itemDescription);
            }
          },
          {
            title: this.$t('purchaseOrderSearch.ddsl'), // 订单数量
            key: 'orderQuantity',
            align: 'center',
            editType: 'Input',
            editable: true,
            width: 130
          },
          {
            title: this.$t('purchaseOrderSearch.yjhl'), // 已交货量
            key: 'deliveredQuantity',
            align: 'center',
            minWidth: 140
          },
          {
            title: this.$t('purchaseOrderSearch.ddzt'), // 订单状态
            key: 'displayedField',
            align: 'center',
            minWidth: 100
          }
        ],
        /* 订单明细 */
        orderDeail_columns: [
          {
            type: 'selection',
            align: 'center',
            width: 35
          },
          {
            title: this.$t('purchaseOrderSearch.kczz'), // 库存组织
            align: 'center',
            key: 'organizationName',
            width: 120,
            render: (h, params) => {
              return h('Tooltip', {
                props: {
                  content: params.row.organizationName.value,
                  placement: 'top'
                },
                class: 'm-tooltip-overflow'
              }, params.row.organizationName.value);
            }
          },
          {
            title: this.$t('purchaseOrderSearch.ddrq'), // 下单日期
            key: 'orderDate',
            align: 'center',
            width: 150,
            sortable: true
          },
          {
            title: this.$t('purchaseOrderSearch.ddh'), // 订单号
            key: 'orderNumber',
            align: 'center',
            width: 120,
            sortable: true
          },
          {
            title: this.$t('purchaseOrderSearch.ddlx'), // 订单类型
            align: 'center',
            key: 'orderType',
            width: 120,
            sortable: true
          },
          {
            title: this.$t('purchaseOrderSearch.ddhh'), // 订单行号
            key: 'orderLineNumber',
            align: 'center',
            width: 80,
            sortable: true
          },
          {
            title: this.$t('purchaseOrderSearch.xqrq'), // 需求日期
            key: 'demandDate',
            align: 'center',
            width: 140,
            sortable: true
          },
          {
            title: this.$t('purchaseOrderSearch.wlbm'), // 物料编码
            key: 'itemCode',
            align: 'center',
            width: 160,
            sortable: true
          },
          {
            title: this.$t('purchaseOrderSearch.wlms'), // 物料描述
            key: 'itemDescription',
            align: 'center',
            width: 300,
            render: (h, params) => {
              return h('Tooltip', {
                props: {
                  content: params.row.itemDescription.value,
                  placement: 'top'
                },
                class: 'm-tooltip-overflow'
              }, params.row.itemDescription.value);
            }
          },
          {
            title: this.$t('purchaseOrderSearch.dw'), // 单位
            key: 'unit',
            align: 'center',
            width: 80
          },
          {
            title: this.$t('purchaseOrderSearch.ddsl'), // 订单数量
            key: 'orderQuantity',
            align: 'center',
            editType: 'Input',
            editable: true,
            width: 110,
            sortable: true
          },
          {
            title: this.$t('purchaseOrderSearch.yjhl'), // 已交货量
            key: 'deliveredQuantity',
            align: 'center',
            width: 80,
            sortable: true
          },
          {
            title: this.$t('ReturnOrderQueryView.returnQuantity'), // 退货数量
            key: 'returnQuantity',
            align: 'center',
            width: 80,
            sortable: true
          },
          {
            title: this.$t('purchaseOrderSearch.wwcl'), // 未完成量
            key: 'unfulfilledQuantity',
            align: 'center',
            width: 80,
            sortable: true
          },
          {
            title: this.$t('importNoticeCommon.t117'),  // 保税属性
            key: 'bondedTradeType',
            align: 'center',
            width: 80,
            sortable: true,
            render: (h, params) => {
                let bondedTradeType = params.row.bondedTradeType;
                if (bondedTradeType && bondedTradeType.value) {
                    return h('span', this.INT_BONDED_TYPE.find((item) => item.value === bondedTradeType.value).email);
                }
            }
          },
          {
            title: this.$t('purchaseOrderSearch.bz'), // 备注
            key: 'remarks',
            align: 'center',
            minWidth: 100
          },
          {
            title: this.$t('purchaseOrderSearch.cgy'), // 仓管员
            key: 'buyer',
            align: 'center',
            width: 200,
            sortable: true
          },
          {
            title: this.$t('purchaseOrderSearch.xmh'), // 项目号
            key: 'projectNo',
            align: 'center',
            width: 150,
            render: (h, params) => {
              let proname = params.row.PROJECT_NAME;
              return h('Tooltip', {
                props: {
                  content: proname,
                  placement: 'top'
                },
                class: 'm-tooltip-overflow'
              }, proname);
            }
          },
          {
            title: this.$t('purchaseOrderSearch.ddzt'), // 订单状态
            key: 'closedCode',
            align: 'center',
            width: 120
          }
        ],
        resultSource: {total: 0, records: [], list: []},
        resultSourceCount: {total: 0, records: [], list: []},
        result: {},
        sourcingstate: {},
        formData: {
          row: 3,
          items: [
            {
              value: '',
              field: 'organizationId', // organizationName
              disabled: false,
              layout: {
                span: 8,
                offset: 0,
                row: 1
              },
              validators: {
                required: {
                  required: true,
                  message: this.$t('purchaseOrderSearch.kczzbx')
                }
              },
              methods: {
                change() {
                }
              },
              options: {
                multiple: false,
                values: []
              },
              type: 'select',
              title: 'purchaseOrderSearch.kczz'
            },
            {
              isDouble: true,
              value: moment(new Date()).subtract(2, 'M')._d,
              field: 'demandDateStart',
              title: 'purchaseOrderSearch.xqrq',
              type: 'datePicker',
              style: 'width:100%',
              layout: {
                row: 1,
                span: 8,
                offset: 0
              },
              validators: {
                required: {
                  required: true,
                  message: this.$t('purchaseOrderSearch.xqrqbx')
                }
              },
              options: {
                type: 'date',
                format: 'yyyy-MM-dd'
              }
            },
            {
              hide: true,
              value: moment(new Date()).add(2, 'M')._d,
              field: 'demandDateEnd',
              title: 'purchaseOrderSearch.xqrq',
              type: 'datePicker',
              style: 'width:100%',
              layout: {
                row: 1,
                span: 8,
                offset: 0
              },
              validators: {
                required: {
                  required: true,
                  message: this.$t('purchaseOrderSearch.xqrqbx')
                }
              },
              options: {
                type: 'date',
                format: 'yyyy-MM-dd'
              }
            },
            {
              value: '',
              field: 'orderNumber', // 订单号
              layout: {
                span: 8,
                offset: 0,
                row: 1
              },
              options: {
                rows: 1
              },
              type: 'text',
              title: this.$t('purchaseOrderSearch.ddh')
            },
            {
              value: '',
              field: 'itemCodeStart',
              layout: {
                span: 8,
                offset: 0,
                row: 2
              },
              options: {
                rows: 1
              },
              type: 'text',
              title: this.$t('purchaseOrderSearch.wlbmc'),
              isDouble: true
            },
            {
              hide: true,
              value: '',
              field: 'itemCodeEnd',
              layout: {
                span: 8,
                offset: 0,
                row: 2
              },
              options: {
                rows: 1
              },
              type: 'text',
              title: this.$t('purchaseOrderSearch.zhi')
            },
            {
              isDouble: true,
              value: '',
              field: 'orderDateStart',
              title: 'purchaseOrderSearch.xdrq',
              type: 'datePicker',
              style: 'width:100%',
              layout: {
                row: 2,
                span: 8,
                offset: 0
              },
              options: {
                type: 'datetime',
                format: 'yyyy-MM-dd HH:mm:ss'
              }
                // change: (item) => {
                //     this.$nextTick(() => {
                //         console.log('11111111', item);
                //         console.log('2222222', item.value);
                //         if (item.value) {
                //             let dateFrom = new Date(item.value);
                //             let returnDate = new Date(new Date(new Date(dateFrom).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);   //  减去一秒，得到23：59：59
                //             console.log('returnDate:', returnDate);
                //             this.formData.items[7].value = returnDate;
                //         }
                //     });
                // }
            },
            {
              hide: true,
              value: '',
              field: 'orderDateEnd',
              title: 'purchaseOrderSearch.xdrq',
              type: 'datePicker',
              style: 'width:100%',
              layout: {
                row: 2,
                span: 8,
                offset: 0
              },
              options: {
                type: 'datetime',
                format: 'yyyy-MM-dd HH:mm:ss'
              }
            },
            {
              value: '',
              field: 'closeDate',
              layout: {
                span: 8,
                offset: 0,
                row: 2
              },
              options: {
                type: 'date',
                format: 'yyyy-MM-dd'
              },
              type: 'datePicker',
              style: 'width:100%',
              title: this.$t('purchaseOrderSearch.gbrq') // 关闭日期
            },
            {
                value: '',
                field: 'bondedTradeType',
                layout: {
                    span: 8,
                    offset: 0,
                    row: 3
                },
                options: {
                multiple: false,
                values: []
                },
                type: 'select',
                title: 'importNoticeCommon.t117', // 保税属性
            },
            {
                value: '',
                field: 'closedCode',
                layout: {
                    span: 8,
                    offset: 0,
                    row: 3
                },
                options: {
                multiple: false,
                values: []
                },
                type: 'select',
                title: 'purchaseOrderSearch.t1', // 状态
            },
            {
              value: this.$t('purchaseOrderSearch.wwcdd'), // '未完成订单',
              field: 'isFinish',
              layout: {
                span: 16,
                offset: 8,
                row: 3
              },
              options: {
                vertical: false,
                values: [
                  {value: 'N', label: this.$t('purchaseOrderSearch.wwcdd')}, // 未完成订单
                  {value: '', label: this.$t('purchaseOrderSearch.xssydd')},
                  {value: 'Y', label: this.$t('purchaseOrderSearch.zxsywcdd')}
                ]
              },
              change: ({value}) => {
                /* 选择所有订单，默认把状态改为OPEN */
                if (value === this.$t('purchaseOrderSearch.xssydd')) {
                    let closedCode = this.getFormDataItemObj(this.formData.items, 'closedCode');
                    if (!closedCode.value) {
                        closedCode.value = 'OPEN';
                    }
                }
              },
              type: 'radio'
            }
          ]
        }
      };
    },
    watch: {
      'currentPanel' (newVal) {
        console.log('currentPanel', newVal);
      },
      formData: {
        handler (newVal) {
          console.log('newVal', newVal);
          newVal.items.map((item, index) => {
            if (item.field === 'itemCodeStart') {
              newVal.items[index + 1].value = item.value;
            }
          });
        },
        deep: true
      }
    },
    methods: {
      tabsClick (name) {
        const _this = this;
        if (name === 'info2') {
          _this.$refs['formDataName'].$children[0].$children[0].$children[0].validate((validate) => {
            if (validate) {
                _this.reSearch();
              }
          });
        } else {
			/* 重置悬浮框样式 */
	        const detailTable = this.$refs.detailTable;
	        detailTable.clearFixedStyle();
	        detailTable.initFixedHeader();
		}
      },
      search() {
        if (new Date(this.getFormDataItemVal(this.formData.items, 'demandDateStart')).getTime() > new Date(this.getFormDataItemVal(this.formData.items, 'demandDateEnd')).getTime()) {
          this.$Modal.error({
            content: this.$t('purchaseOrderSearch.xqrqxy')
          });
          return false;
        }
        this.loading = true;
        let params = {};
        this.formData.items.map((item) => {
          if (item.type === 'datePicker') {
            if (item.field === 'demandDateStart' || item.field === 'orderDateStart') {
              params[item.field] = item.value ? (item.field === 'orderDateStart' ? moment(item.value).format('YYYY-MM-DD HH:mm:ss') : moment(item.value).format('YYYY-MM-DD 00:00:00')) : '';
            } else {
              params[item.field] = item.value ? (item.field === 'orderDateEnd' ? moment(item.value).format('YYYY-MM-DD HH:mm:ss') : moment(item.value).format('YYYY-MM-DD 23:59:59')) : '';
            }
          } else {
            params[item.field] = item.field === 'isFinish' ? this.filter(item.value) : item.value;
            if (item.field === 'organizationId') {
              this.orgList.forEach((element) => {
                if (element.value === this.formData.items[0].value) {
                  params.erpOrgId = element.erpOrgId;
                }
              });
            }
          }
        });
        console.log('---params::', params);
        this.queryParam = {
          language: this.currLang, // 必填
          vendorCode: this.supplierCode, // 必填，供应商编码
          demandDate: '', // 精准查询,需求日期
          orderDate: '', // 精准查询,下单日期
          mdmCode: this.mdmCode,
          page: this.page,
          pageIndex: this.page, // 查询第几页,为空默认第一页
          pageSize: this.pageSize, // 每页查询数据量，为空默认查99999
          ...params
        };
        if (this.currentPanel === 'info1') {
          axios.post('/gscint/ierp/purchaseOrder/queryIerpPurchaseOrder', this.queryParam).then(res => {
            console.log('---info1-res::', res);
            if (res.data.data.success) {
              this.loading = false;
              let param = {};
              param.vendorId = this.supplierId;
              param.gysCode = this.supplierCode;
              this.formData.items.map((item) => {
                if (item.type === 'datePicker') {
                  if (item.field === 'demandDateStart' || item.field === 'orderDateStart') {
                    param[item.field] = item.value ? (item.field === 'orderDateStart' ? moment(item.value).format('YYYY-MM-DD HH:mm:ss') : moment(item.value).format('YYYY-MM-DD 00:00:00')) : '';
                  } else {
                    param[item.field] = item.value ? (item.field === 'orderDateEnd' ? moment(item.value).format('YYYY-MM-DD HH:mm:ss') : moment(item.value).format('YYYY-MM-DD 23:59:59')) : '';
                  }
                } else {
                  param[item.field] = item.field === 'isFinish' ? this.filter(item.value) : item.value;
                }
              });
              this.resultSource.list = this.list2tableDate(res.data.data.datas.list);
              this.resultSource.list.forEach(item => {
                  item.orderDate.value = item.orderDate.value ? item.orderDate.value : moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
              });
              this.resultSource.total = res.data.data.datas.total;
            } else {
              this.loading = false;
              this.$Modal.error({
                title: this.$t('common.warn'),
                content: this.$t('common.error1')
              });
            }
          });
        } else {
          let queryIerpPurchaseOrderUrl = '/gscint/ierp/purchaseOrder/queryIerpPurchaseOrderSum';
          axios.post(queryIerpPurchaseOrderUrl, this.queryParam).then(res => {
            if (res.data.data.success) {
              this.loading = false;
              this.resultSourceCount = {
                list: res.data.data.datas.list,
                total: res.data.data.datas.total
              };
            } else {
              this.$Modal.error({
                title: this.$t('common.warn'),
                content: res.msg
              });
            }
          });
        }
      },
      filter (val) {
        if (val === this.$t('purchaseOrderSearch.xssydd')) {
          return '';
        } else if (val === this.$t('purchaseOrderSearch.zxsywcdd')) {
          return 'Y';
        } else {
          return 'N';
        }
      },
      /** 订单【汇总】导出 */
      exportOrderCountAsyncExcel() {
        let param = {}; // 参数
        param.vendorId = this.supplierId;
        param.gysCode = this.supplierCode;

        this.formData.items.map((item) => {
          if (item.type === 'datePicker') {
            if (item.field === 'demandDateStart' || item.field === 'orderDateStart') {
              param[item.field] = item.value ? (item.field === 'orderDateStart' ? moment(item.value).format('YYYY-MM-DD HH:mm:ss') : moment(item.value).format('YYYY-MM-DD 00:00:00')) : '';
            } else {
              param[item.field] = item.value ? (item.field === 'orderDateEnd' ? moment(item.value).format('YYYY-MM-DD HH:mm:ss') : moment(item.value).format('YYYY-MM-DD 23:59:59')) : '';
            }
          } else {
            param[item.field] = item.field === 'isFinish' ? this.filter(item.value) : item.value;
            if (item.field === 'organizationId') {
              this.orgList.forEach((element) => {
                if (element.value === this.formData.items[0].value) {
                  param.erpOrgId = element.erpOrgId;
                }
              });
            }
          }
        });

        let params = {
          language: this.filterLang(), // 必填
          vendorCode: this.supplierCode, // 必填，供应商编码
          demandDate: '', // 精准查询,需求日期
          orderDate: '', // 精准查询,下单日期
          mdmCode: this.mdmCode,
          pageIndex: this.page,
          pageSize: 99999,
          ...param
        };
        this.exportLoading = true;
        var a = document.createElement('a');
        a.href = '/gscint/ierp/purchaseOrder/exportIerpPurchaseOrderSum?paraJson=' + encodeURI(JSON.stringify(params));
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => {
          this.exportLoading = false;
        }, 5000);
      },
      /** 订单【明细】导出 */
      exportOrderDetailAsyncExcel() {
        let param = {};
        this.formData.items.map((item) => {
          if (item.type === 'datePicker') {
            if (item.field === 'demandDateStart' || item.field === 'orderDateStart') {
              param[item.field] = item.value ? (item.field === 'orderDateStart' ? moment(item.value).format('YYYY-MM-DD HH:mm:ss') : moment(item.value).format('YYYY-MM-DD 00:00:00')) : '';
            } else {
              param[item.field] = item.value ? (item.field === 'orderDateEnd' ? moment(item.value).format('YYYY-MM-DD HH:mm:ss') : moment(item.value).format('YYYY-MM-DD 23:59:59')) : '';
            }
          } else {
            param[item.field] = item.field === 'isFinish' ? this.filter(item.value) : item.value;
            if (item.field === 'organizationId') {
              this.orgList.forEach((element) => {
                if (element.value === this.formData.items[0].value) {
                  param.erpOrgId = element.erpOrgId;
                }
              });
            }
          }
        });
        let params = {
          language: this.filterLang(), // 必填
          vendorCode: this.supplierCode, // 必填，供应商编码
          demandDate: '', // 精准查询,需求日期
          orderDate: '', // 精准查询,下单日期
          mdmCode: this.mdmCode,
          pageIndex: this.page,
          pageSize: 99999,
          ...param
        };
        this.exportLoading = true;
        var a = document.createElement('a');
        a.href = '/gscint/ierp/purchaseOrder/exportIerpPurchaseOrder?paraJson=' + encodeURI(JSON.stringify(params));
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => {
            this.exportLoading = false;
        }, 5000);
      },
      /** 获取登录用户信息
       * @param isReLoad 1：不读取redis数据，重新获取数据库数据
       */
      getVendorIERP(callBack) {
        let url = '/gscint/vendor/getVendorIERP';
        axios.get(url, {
        }).then(res => {
          if (res.data.data.success) {
            this.supplierId = res.data.data.datas.vendorId;
            this.supplierCode = res.data.data.datas.vendorCode;
            // this.mdmCode = res.data.data.datas.mdmCode; // 为IERP的供应商编码
          }
          callBack && callBack();
        });
      },
      getMdmCode() {
        axios.post('/gscint/vendor/queryMdmCodeByVendorCode', {
          vendorCode: this.supplierCode
        }).then(res => {
          if (res.data.data.success) {
            this.mdmCode = res.data.data.datas; // 为IERP的供应商编码
          }
        });
      },
      list2tableDate(list) {
        let datas = [];
        list.forEach(m => {
          var newM = {};
          for (var en in m) {
            newM[en] = {value: m[en]};
          }
          datas.push(newM);
        });
        return datas;
      },
      reSearch() {
        if (this.currentPanel === 'info1') {
          this.page = 1;
        } else {
          this.pageCount = 1;
        }
        this.search();
      },
      pageChage(page) {
        this.page = page;
        this.search();
      },
      pageSizeChange(pageSize) {
        this.pageSize = pageSize;
        this.search();
      },
      pageChageCount(page) {
        this.pageCount = page;
        this.search();
      },
      pageSizeChangeCount(pageSize) {
        this.pageSizeCount = pageSize;
        this.search();
      },
      /* 获取库存组织 */
      getOrganizationName: function () {
        this.getSRMInvLovListNew((data) => {
            const orgList = data.map(({ organizationName, erpOrgId }) => {
                return {
                    label: organizationName,
                    value: erpOrgId,
                    erpOrgId,
                };
            });
            this.getFormDataItemObj(this.formData.items, 'organizationId').options.values = orgList;
            this.orgList = orgList;
        });
      },
      handleSelectionChange (selection) {
        this.selection = selection;
      },
      filterLang() {
        if (this.currLang === 'zh-CN') {
            return 'ZHS';
        } else if (this.currLang === 'en-US') {
            return 'US';
        } else if (this.currLang === 'ja-JP'){
            return 'JA';
        } else {return 'ZHS'};
      },
      setDetailTableUpdate(columns) {
        this.orderDeail_columns = columns;
      },
      setSumTableUpdate(columns) {
        this.orderCount_columns = columns;
      },
    },
    mounted() {
      this.vendorUser = JSON.parse(localStorage.getItem('user'));
      this.getVendorIERP(() => {
        this.getMdmCode();
      });
      this.getOrganizationName();
      this.getDict('INT_BONDED_TYPE', (data) => {
        data.forEach((item) => {
            item.label = item.email;
        });
        this.getFormDataItemObj(this.formData.items, 'bondedTradeType').options.values = data;
      });
      this.getDict('INT_PO_STATUS', (data) => {
        this.getFormDataItemObj(this.formData.items, 'closedCode').options.values = data;
      });
    }
  };
</script>
<style lang="less" scoped>
.ml10 {
    margin-left: 10px;
}
</style>
